<template>
    <div class="modal-backdrop" @click.self="close">
      <div class="modal-content">
        <button class="close-btn" @click="close">×</button>
        <h2>Datenschutzerklärung</h2>
        <div class="privacy-content">
          <p>
            Ihre Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage verwendet und nicht an Dritte weitergegeben. 
            Weitere Informationen zum Umgang mit Ihren Daten finden Sie in unserer vollständigen <a href="https://theaesthetics.at/datenschutz" target="_blank">Datenschutzerklärung</a>.
          </p>
          <p>
            <strong>Verantwortlicher:</strong> TheAesthetics Bartsch² GmbH, Grinzinger Allee 19, 1190 Wien<br>
            <strong>Zweck:</strong> Bearbeitung Ihrer Anfrage und Kontaktaufnahme<br>
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
          </p>
          <p>
            Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer Daten sowie das Recht auf Datenübertragbarkeit. 
            Bei Fragen wenden Sie sich bitte an office@theaesthetics.at.
          </p>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  // @vue/compiler-sfc macro global
  // eslint-disable-next-line no-undef
  const emit = defineEmits(['close'])
  const close = () => emit('close')
  </script>
  
  <style scoped>
  .modal-backdrop {
    position: fixed;
    z-index: 1000;
    inset: 0;
    background: rgba(0,0,0,0.4);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-content {
    background: #fff;
    border-radius: 16px;
    padding: 2rem;
    max-width: 500px;
    width: 90vw;
    position: relative;
    box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  }
  .close-btn {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: none;
    border: none;
    font-size: 2rem;
    cursor: pointer;
  }
  .privacy-content {
    margin-top: 1.5rem;
    font-size: 1rem;
    color: #333;
  }
  </style>